const replacePlaceholder = () => {
    const regex = /{{(.*?)}}/g;

    const replaceFn = (prod) => (match, p1) => {
        const propertyName = p1.trim();
        return prod[propertyName] || "";
    };

    const replaceFnWith = (replaceText) => () => {
        return replaceText;
    };

    return {
        regex,
        replaceFn,
        replaceFnWith,
    };
};

export default replacePlaceholder;
